/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Max_Players_DescInputs */



/**
* | output |
* | --- |
* | "Venue capacity. Sign-ups past it go to the waitlist; players you add yourself don't." |
*
* @param {Tfield_Max_Players_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_max_players_desc = /** @type {((inputs?: Tfield_Max_Players_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Max_Players_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Capacité de la salle. Au-delà, les inscriptions vont en liste d'attente ; les joueurs que vous ajoutez vous-même, non.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aforo del local. Por encima, las inscripciones van a la lista de espera; los jugadores que añade usted mismo, no.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Capacidade do local. Acima dela, as inscrições vão para a lista de espera; jogadores que você mesmo adiciona, não.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Capienza della sala. Oltre, le iscrizioni finiscono in lista d'attesa; i giocatori che aggiungi tu, no.")
	return /** @type {LocalizedString} */ ("Venue capacity. Sign-ups past it go to the waitlist; players you add yourself don't.")
});